/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Manager
 */
export interface Manager {
    /**
     * 
     * @type {string}
     * @memberof Manager
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Manager
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Manager
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Manager
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Manager
     */
    inactive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Manager
     */
    photo?: string;
}

/**
 * Check if a given object implements the Manager interface.
 */
export function instanceOfManager(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ManagerFromJSON(json: any): Manager {
    return ManagerFromJSONTyped(json, false);
}

export function ManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Manager {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'inactive': !exists(json, 'inactive') ? undefined : json['inactive'],
        'photo': !exists(json, 'photo') ? undefined : json['photo'],
    };
}

export function ManagerToJSON(value?: Manager | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'inactive': value.inactive,
        'photo': value.photo,
    };
}

